
import { RefreshTime } from '@/common/enums/RefreshTime';
import { firstUpperString } from '@/common/helpers/FirstUpperString';
import { isAllowedChannel } from '@/common/helpers/ModuleHelpers';
import { createNamespacedHelpers } from '@/common/vuex-composition-hooks';
import { IAuthActions, IAuthGetters, IAuthState } from '@/modules/login/types';
import router from '@/router';
import { ROUTE_NAMES } from '@/router/routes';
import { defineComponent, onMounted, onUnmounted, reactive, toRefs } from 'vue';
import * as vueRouter from 'vue-router';
const { useState, useActions } = createNamespacedHelpers<
  IAuthState,
  IAuthGetters,
  IAuthActions
>('auth');

interface ITab {
  id: number;
  name?: string;
  fullname?: string;
  active?: boolean;
  code?: any;
  route?: string;
  codeChannel: number;
}

interface State {
  tabs: ITab[];
  tabActive: any;
}

export default defineComponent({
  name: 'Tabs',

  setup(props, { emit }) {
    const { setNextBillingUnit, setActiveModule } = useActions([
      'setNextBillingUnit',
      'setActiveModule',
    ]);
    const { salesChannel } = useState(['salesChannel']);
    const state: State = reactive<State>({
      tabs: [],
      tabActive: '',
    });

    salesChannel?.value?.forEach((el) => {
      state.tabs.push({
        id: el.id,
        name: firstUpperString(el.name),
        fullname:
          el.name == 'export' ? 'Exportação' : firstUpperString(el.name),
        active: false,
        route:
          el.name == 'ecomm'
            ? ROUTE_NAMES.ECOMMERCE
            : ROUTE_NAMES[el.name.toUpperCase()],
        codeChannel: el.code,
      });
    });

    const isActiveTab = (pTabs) => {
      const route = vueRouter.useRoute();
      return pTabs.codeChannel === route.meta.codeChannel;
    };

    const handleTabChange = async (
      tabIndex: number,
      clearRefreshTime: boolean
    ) => {
      state.tabs.forEach((tab: ITab) => {
        tab.active = false;
      });

      const tab = state.tabs[tabIndex];

      state.tabActive = tab;

      if (tab) tab.active = true;

      if (tabIndex === 0) await setNextBillingUnit();

      await setActiveModule(tab.code);

      await router.push({ name: tab?.route });

      if (clearRefreshTime) {
        clearInterval(refreshTimer);
        refreshTimer = setInterval(handleRefreshTab, RefreshTime.TIMES);
      }
    };

    const handleRefreshTab = async () => {
      let tabIndex = state.tabs.indexOf(state.tabActive) + 1;

      if (tabIndex >= state.tabs.length) {
        emit('alterBillingUnit');
      }
      await handleTabChange(tabIndex, false);
    };

    let refreshTimer: number;

    const init = async () => {
      const route = vueRouter.useRoute();

      state.tabActive = route.meta.codeChannel;

      const tab = state.tabs.find(
        (tab: ITab) => tab.codeChannel === state.tabActive
      );

      if (tab) {
        tab.active = true;
        state.tabActive = tab;
      } else {
        const tabActive = state.tabs[0];
        if (tabActive) {
          state.tabActive = tabActive;
          tabActive.active = true;
        }
      }

      refreshTimer = setInterval(handleRefreshTab, RefreshTime.TIMES);
    };

    onMounted(init);
    onUnmounted(() => clearInterval(refreshTimer));
    return {
      ...toRefs(state),
      isActiveTab,
      handleTabChange,
      isAllowedChannel,
    };
  },
});
